import type { IVendor } from '@/interfaces'
import type { IWorkOrderJobForm } from '@/interfaces/jobs/work-orders/IWorkOrderJobForm'
import { Vendor } from '@/models/vendors'
import JobForm from '../JobForm'
import { JobType } from '@/enum'

class WorkOrderJobForm extends JobForm implements IWorkOrderJobForm {
  workOrderVendorId: string
  workOrderUrl: string
  workOrderVendor: IVendor

  constructor(jobForm?: any) {
    super(jobForm)
    this.type = JobType.WORK_ORDER
    this.workOrderVendorId = jobForm?.workOrderVendorId
    this.workOrderUrl = jobForm?.workOrderUrl
    this.workOrderVendor = new Vendor(jobForm?.workOrderVendor)
  }
}

export default WorkOrderJobForm
